module.exports = __webpack_public_path__ + "Roboto-Black.4c3b6229efe63a13dbb4.woff";


//////////////////
// WEBPACK FOOTER
// /Users/rujuta/Desktop/Projects/agiletimes-master/node_modules/roboto-fontface/fonts/roboto/Roboto-Black.woff
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-Black.woff
// module chunks = styles